import {
  Autocomplete,
  Card,
  CardContent,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { useAppDispatch, useAppSelector } from 'reduxStore/hooks';
import { Result } from 'reduxStore/searchPatientByMRN/Model';
import { searchPatientDetailsByDocumentId } from 'reduxStore/searchPatientByMRN/searchPatientByDocumentIdSlice';
import { PatientSearchFromEHRDetails } from './Model';
import { toggleAppBarLoading } from 'reduxStore/appLoader/toggleAppBarLoadingSlice';

type PatientList = {
  label: string;
  value: number;
};

type Props = {
  updateSearchPatientDetails: (value: PatientSearchFromEHRDetails) => void;
};

function PatientSearchFromEHR({ updateSearchPatientDetails }: Props) {
  const dispatch = useAppDispatch();
  //   const [patientName, setPatientName] = useState('');
  const [searchPatientDetails, setSearchPatientDetails] = useState('');
  //   const [patientuuid, setPatientuuid] = useState('');
  const searchPatientDetailsByDocumentIdResponse = useAppSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.searchPatientDetailsByDocumentIdRes,
  );
  useEffect(() => {
    dispatch(toggleAppBarLoading(searchPatientDetailsByDocumentIdResponse?.loading))
    if (searchPatientDetailsByDocumentIdResponse?.response !== undefined) {
      if (searchPatientDetailsByDocumentIdResponse?.response?.results !== undefined) {
        setPatientDetailsList(searchPatientDetailsByDocumentIdResponse?.response?.results);
        setPatientList(
          searchPatientDetailsByDocumentIdResponse?.response?.results.map((item: Result) => {
            const [value, label] = item.display.split(' - ');
            return {
              label: label,
              value: value,
            };
          }),
        );
      } else {
        setPatientDetailsList([] as Result[]);
        setPatientList([]);
      }
    } else {
      setPatientDetailsList([] as Result[]);
      setPatientList([]);
    }
  }, [searchPatientDetailsByDocumentIdResponse]);
  const [patientList, setPatientList] = useState([] as PatientList[]);
  const [patientDetailsList, setPatientDetailsList] = useState([] as Result[]);
  const [selectedPatient, setSelectedPatient] = useState<PatientList | null>(null);
  const changeSelectedPatient = (passedVal: PatientList | null) => {
    setSelectedPatient(passedVal);
    updateSearchPatientDetails({
      patientMRN:
        patientDetailsList
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .find((item: Result) => item.display.includes(String(passedVal?.value)))
          ?.display.split(' - ')[0] || '',
      patientName:
        patientDetailsList
          .find((item: Result) => item.display.includes(String(passedVal?.value)))
          ?.display.split(' - ')[1] || '',
      patientUUID:
        patientDetailsList.find((item: Result) => item.display.includes(String(passedVal?.value)))
          ?.uuid || '',
    });
  };

  return (
    <Card>
      <CardContent>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'
          spacing={2}
        >
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography variant='subtitle2' color='primary' sx={{ mb: 1, fontWeight: 'bold' }}>
              STEP 1: Search MRN / Phone / Phone No / ID Card
            </Typography>
            <TextField
              fullWidth
              placeholder='Enter MRN or Phone Number or ID Card Number'
              value={searchPatientDetails}
              onChange={(event) => setSearchPatientDetails(event.target.value)}
              disabled={searchPatientDetailsByDocumentIdResponse?.loading}
              size='small'
              onKeyDown={(event: React.KeyboardEvent) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  dispatch(
                    searchPatientDetailsByDocumentId({
                      documentIDNumber: searchPatientDetails,
                    }),
                  );
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='start'>
                    <IconButton
                      aria-label='toggle password visibility'
                      disabled={
                        searchPatientDetails.length === 0 ||
                        searchPatientDetailsByDocumentIdResponse?.loading
                      }
                      onClick={() =>
                        dispatch(
                          searchPatientDetailsByDocumentId({
                            documentIDNumber: searchPatientDetails,
                          }),
                        )
                      }
                      onMouseDown={() =>
                        dispatch(
                          searchPatientDetailsByDocumentId({
                            documentIDNumber: searchPatientDetails,
                          }),
                        )
                      }
                      edge='end'
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography variant='subtitle2' color='primary' sx={{ mb: 1, fontWeight: 'bold' }}>
              STEP 2: Select from Available List
            </Typography>
            <Autocomplete
              fullWidth
              size='small'
              // disabled={setPreferenceValueRes?.loading}
              value={selectedPatient}
              options={patientList}
              disabled={
                patientList.length === 0 || searchPatientDetailsByDocumentIdResponse?.loading
              }
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onChange={(_event: any, newValue: any) => {
                changeSelectedPatient(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label='Select Patient' variant='outlined' />
              )}
              getOptionLabel={(option) => `${option.label}`}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              isOptionEqualToValue={(option: any, value) => option.id === value.value}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default PatientSearchFromEHR;
